module.exports = __webpack_public_path__ + "static/media/dummies_2.66c2968c.jpg";